// src/utils/ExitIntent.js

import { throttle } from "lodash"

export default function ExitIntent(options = {}) {
  const defaultOptions = {
    threshold: 20,
    maxDisplays: 1,
    eventThrottle: 200,
    scrollUpPercent: 10,
    onExitIntent: () => {},
  }

  let thresholdMet = false;
  let windowHeight = 0;
  let maxScrollY = 0;

  return (function() {
    const config = { ...defaultOptions, ...options }
    const eventListeners = new Map()
    let displays = 0

    const addEvent = (eventName, callback) => {
      document.addEventListener(eventName, callback, false)
      eventListeners.set(`document:${eventName}`, { eventName, callback })
    }

    const removeEvent = key => {
      const { eventName, callback } = eventListeners.get(key)
      document.removeEventListener(eventName, callback)
      eventListeners.delete(key)
    }

    const shouldDisplay = position => {
      if(position > config.threshold){
        thresholdMet = true;
      }

      if (thresholdMet && position <= config.threshold && displays < config.maxDisplays) {
        displays++
        return true
      }
      return false
    }

    const mouseDidMove = event => {
      if (shouldDisplay(event.clientY)) {
        config.onExitIntent()
        if (displays >= config.maxDisplays) {
          removeEvents()
        }
      }
    }

    const removeEvents = () => {
      eventListeners.forEach((value, key, map) => removeEvent(key))
    }

    const isScrollingUp = position => {
      if(typeof window != 'undefined'){
        windowHeight = window.innerHeight;
      }
      
      if(windowHeight > 0 && window.innerWidth < 599){
        if(position > 0 && position > maxScrollY){
          maxScrollY = position;
        }
        let delta = ((maxScrollY - position) / windowHeight * 100);
        if(delta > config.scrollUpPercent){
          displays++
          return true;
        }
      }
      
      return false;
    }

    const checkScroll = event => {
      if(isScrollingUp(event.target.scrollingElement.scrollTop)){
        config.onExitIntent();
        if (displays >= config.maxDisplays) {
          removeEvents()
        }
      }
    }

    addEvent("mousemove", throttle(mouseDidMove, config.eventThrottle))
    addEvent("scroll", throttle(checkScroll, config.eventThrottle * 2)); // check scroll half as often

    return removeEvents
  })()
}